<div class="flex flex-col gap-medpace">
    <mds-expansion-panel [panelTitle]="'Visits'" [description]="''" [attr.data-cy]="`visits`">
        <div class="flex flex-row gap-medpace items-center mb-medpace">
            <h5 class="col-start-1 col-span-1">Currency:</h5>

            @if (currencyCode$.source$ | async; as currencyCode) {
                <mds-tag
                    class="primary-tag"
                    [variant]="'category'"
                    [label]="currencyCode"
                    [categoryIcon]="'payments'"
                ></mds-tag>
            }
        </div>
        @let studyVisitGroupsVMs = studyVisitGroupsVMs$.source$ | async;
        @for (groupVM of studyVisitGroupsVMs; track $index) {
            <mds-expansion-panel
                [panelTitle]="groupVM.title"
                [description]="''"
                [attr.data-cy]="`visit-stipend-group-${$index}`"
            >
                <div class="flex flex-col gap-medpace">
                    <div class="w-full grid grid-cols-4 gap-medpace">
                        <h5 class="col-span-2 col-start-1 text-mds-blue">Visit Name</h5>
                        <h5 class="text-center text-mds-blue">Stipend?</h5>
                        <h5 class="text-center text-mds-blue">Amount<span class="required-asterisk">*</span></h5>
                    </div>
                    @for (studyVisitVM of groupVM.studyVisitVMs; track $index) {
                        <medpace-single-stipend-visit
                            [formGrp]="studyVisitVM.formGroup"
                            [displayName]="studyVisitVM.studyVisit.name"
                            [mode]="mode()"
                            [existingStipend]="studyVisitVM.existingStipend ?? undefined"
                            [studyVisit]="studyVisitVM.studyVisit"
                        />
                    }
                </div>
            </mds-expansion-panel>
        }
    </mds-expansion-panel>
</div>
